<template>
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <v-icon v-if="isTester" v-bind="attrs" v-on="on" color="green" small>
        mdi-check-bold
      </v-icon>
      <v-icon v-else v-bind="attrs" v-on="on" color="grey lighten-1" small>
        mdi-close-thick
      </v-icon>
    </template>
    {{ $t(`realEstateUsers.isTester.${isTester}`) }}
  </v-tooltip>
</template>

<script>
export default {
  name: 'RealEstateUserIsTester',

  props: {
    isTester: {
      type: Boolean,
    },
  },
}
</script>
